import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import swal from "sweetalert";
import axios from "axios";
import ImageModal from "./Image";

const Promotionproduct = () => {
  // ====================modal====================
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [allcategory, updateCategory] = useState([]);
  const baseUrl = `https://apimlm.bloomitsolutions.in`

  // ====================modal====================

  // ====================file upload======================


  // ====================file upload======================

  const [allpromotion, UpdatePromotion] = useState([]);

  const [type, pickType] = useState("");
  const [price, pickPrice] = useState("");
  const [img, pickImg] = useState("");


  const getpromotion = () => {
    axios.get('https://apimlm.bloomitsolutions.in/ecomroutes/getProducts')
      .then((response) => {
        const empData = response.data;
        UpdatePromotion(empData);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
      });
  };

  useEffect(() => {
    getpromotion();
  }, []);

  const save = () => {
    if (proid === 0) {
      let url = "http://localhost:1234/promotionalproductlist";
      let proinfo = {
        "type": type,
        "image": img,
        "price": price
      };

      axios
        .post(url, proinfo) // Use Axios post method
        .then((response) => {
          swal(type, "Save Successfully", "success");
          pickType("");
          pickImg("");
          pickPrice("");
          getpromotion();

        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      let url = `http://localhost:1234/promotionalproductlist/${proid}`;

      let proinfo = {
        "type": type,
        "image": img,
        "price": price
      };

      axios
        .patch(url, proinfo) // Use Axios patch method for update
        .then((response) => {
          swal(type, "Update Successfully", "success");
          pickType("");
          pickImg("");
          pickPrice("");

          getpromotion();
          updatePro(0);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const delpromotion = (id, type) => {
    let url = `http://localhost:1234/promotionalproductlist/${id}`;

    axios
      .delete(url) // Use Axios delete method
      .then((response) => {
        swal(type, "Deleted Successfully", "success");
        getpromotion();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  let [proid, updatePro] = useState(0);
  let [mybtn, updateBtn] = useState("Save ");

  const editPromotion = (index) => {
    updatePro(allpromotion[index].id);
    updateBtn("Update ");

    pickType(allpromotion[index].type);
    pickImg(allpromotion[index].image);
    pickPrice(allpromotion[index].price);
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };

  const deleteCategory = (categoryId, categoryName) => {
    axios
      .delete(`https://apimlm.bloomitsolutions.in/ecomroutes/deleteProduct?id=${categoryId}`)
      .then((response) => {
        if (response.data.success) {
          // Filter out the deleted category from the list
          const updatedCategories = allcategory.filter(category => category.id !== categoryId);
          updatedCategories(updatedCategories);
          
          // swal("Success", `Category ${categoryName} deleted successfully`, "success");
        } else {
          console.error("Server response:", response);
          // swal("Error", `Failed to delete category: ${response.data.message}`, "error");
        }
      })
      .catch((error) => {
        console.error("Request error:", error);
        // swal("Error", `Failed to delete category: ${error.message}`, "error");
      });
  };

  return (
    <section>
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>All Products</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of All Products</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3"></div>

                    {/* <div className="col-lg-3">
                      <button
                        className="btn btn-success"
                        variant="primary"
                        onClick={handleShow}
                      >
                        View All Products
                      </button> */}
                    {/* </div> */}
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th> Sl.No </th>
                          <th>ID</th>
                          <th>Category Name</th>
                          <th>Product Name</th>
                          <th>Price 1</th>
                          <th>Price 2</th>
                          <th>Discount</th>
                          <th>Product Description</th>
                          <th>Quantity</th>
                          <th>Image 1</th>
                          <th>Image 2</th>
                          <th>Image 3</th>
                          <th>Image 4</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {
                          allpromotion.map((promotion, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{promotion.id}</td>
                                <td>{promotion.cetogery_name}</td>
                                <td>{promotion.product_name}</td>
                                <td>{promotion.price1}</td>
                                <td>{promotion.price2}</td>
                                <td>{promotion.discount}</td>
                                <td>{promotion.product_discription}</td>
                                <td>{promotion.quantity}</td>
                                <td><img src={`${baseUrl}/${promotion.image1}`} onClick={() => openImageModal(`${baseUrl}/${promotion.image1}`)} className="img-fluid" /></td>
                                <td><img src={`${baseUrl}/${promotion.image2}`} onClick={() => openImageModal(`${baseUrl}/${promotion.image2}`)} className="img-fluid" /></td>
                                <td><img src={`${baseUrl}/${promotion.image3}`} onClick={() => openImageModal(`${baseUrl}/${promotion.image3}`)} className="img-fluid" /></td>
                                <td><img src={`${baseUrl}/${promotion.image4}`} onClick={() => openImageModal(`${baseUrl}/${promotion.image4}`)} className="img-fluid" /></td>
                                <td>{promotion.status}</td>
                                <td>
                                <button
                                  className="btn btn-success mx-2"
                                  // onClick={() => deleteCategory(promotion.id, promotion.cetogery_name)}
                                >
                                  Approve
                                </button>
                                  <button
                                  className="btn btn-danger"
                                  onClick={() => deleteCategory(promotion.id, promotion.cetogery_name)}
                                >
                                  Delete
                                </button>
                                </td>
                                {/* <td>{promotion.updatedAt}</td> */}
                                {/* <td> */}
                                {/* <button
                                  onClick={function () {
                                    editPromotion(index);
                                    handleShow();
                                  }.bind(this)}
                                >
                                  Edit
                                </button>
                                        <button onClick={delpromotion.bind(this,promotion.id,promotion.type)}> Delete </button>
                                    </td> */}
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* ========================modal start=============== */}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add PromotionalProduct</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Type</Form.Label>
              <Form.Control type="text" placeholder="Enter Type" onChange={e => pickType(e.target.value)} value={type} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Image</Form.Label>
              <Form.Control type="file" placeholder="Enter url" onChange={e => pickImg(e.target.value)} value={img} />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Price</Form.Label>
              <Form.Control type="number" placeholder="Enter price" onChange={e => pickPrice(e.target.value)} value={price} />
            </Form.Group>


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              save();
              handleClose();
            }}>
              {mybtn}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}
    </section>
  );
};


export default Promotionproduct;
